
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function MumbaiDarshancabs() {



  const cardData =
  {
    keyword: 'Mumbai Darshan Cabs Service',
    heading: 'AB Ghule Cabs: Mumbai Darshan Cabs Service',
    headingDescription: 'Explore the bustling city of dreams with AB Ghule Cabs’ Mumbai Darshan Service. Whether you are a first-time visitor or a local looking to rediscover Mumbai, we provide a comfortable and seamless travel experience. With well-maintained vehicles and experienced drivers, our service ensures you enjoy the city is iconic landmarks, cultural hotspots, and scenic beauty in style and convenience.',

    top: 'Top Places to Visit in Mumbai with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Gateway of India",
          description: "A majestic symbol of Mumbai’s colonial heritage, the Gateway of India stands tall by the Arabian Sea. The monument was built in honor of King George V's visit in 1911, showcasing Indo-Saracenic architecture. It serves as a prime tourist attraction and is the starting point for ferries to Elephanta Caves, offering great photo opportunities and a glimpse into Mumbai’s rich history."
        },
        {
          title: "Marine Drive",
          description: "Dubbed the 'Queen’s Necklace,' Marine Drive is a curved boulevard along the Arabian Sea, known for its glittering lights at night. It offers unparalleled views of the sea and city skyline, making it a favorite for leisurely walks and drives. It’s especially popular during sunset and is a perfect spot for couples and families alike."
        },
        {
          title: "Chhatrapati Shivaji Maharaj Terminus (CST)",
          description: "A UNESCO World Heritage Site, CST is a historic railway station known for its intricate Victorian Gothic Revival architecture. This transportation hub is a testament to Mumbai's colonial past and remains an iconic structure, offering a glimpse into the city’s rich architectural and cultural heritage."
        },
        {
          title: "Elephanta Caves",
          description: "Located a ferry ride from the Gateway of India, the Elephanta Caves are a UNESCO World Heritage Site showcasing ancient rock-cut sculptures dedicated to Lord Shiva. The caves are masterpieces of Indian art and architecture, with intricate carvings depicting Hindu mythology and providing a tranquil environment for reflection and exploration."
        },
        {
          title: "Siddhivinayak Temple",
          description: "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of Mumbai’s most famous spiritual landmarks. Known for its beautiful architecture and serene ambiance, the temple attracts devotees seeking blessings and spiritual peace. The golden idol of Ganesha is the centerpiece, drawing visitors from across India and the world."
        },
        {
          title: "Haji Ali Dargah",
          description: "Situated on an islet off Worli, Haji Ali Dargah is a blend of Indo-Islamic architecture and spirituality. Visitors can walk the path to the shrine during low tide, making it a surreal and mesmerizing experience. It is a sacred site for devotees and a peaceful place for reflection, offering a connection between the land and sea."
        },
        {
          title: "Colaba Causeway",
          description: "Colaba Causeway is a vibrant shopping street, perfect for those who love quirky items, ethnic jewelry, and fashionable clothes. It is also home to iconic eateries like Leopold Cafe. The street is a bustling hub of activity, providing a delightful mix of shopping, dining, and cultural experiences."
        },
        {
          title: "Juhu Beach",
          description: "Juhu Beach is a popular beach known for its lively atmosphere, mouthwatering street food, and beautiful sunsets. It is a favorite spot for locals and tourists alike, offering a perfect mix of relaxation and recreation. The beach is a great place to enjoy classic Mumbai snacks and watch the waves crash along the shore."
        },
        {
          title: "Bandra-Worli Sea Link",
          description: "An engineering marvel, the Bandra-Worli Sea Link is a cable-stayed bridge connecting Bandra to South Mumbai. It offers spectacular views of the city skyline and the Arabian Sea, making it a must-see landmark. The bridge is especially beautiful at night when illuminated, creating a stunning visual spectacle."
        },
        {
          title: "Film City",
          description: "Bollywood’s heart, Film City is a sprawling complex where movies and TV shows are filmed. Located in Goregaon, it offers guided tours, allowing visitors to explore movie sets, soundstages, and outdoor locations. It is an exciting experience for cinephiles to witness the magic of Indian cinema up close."
        }
      ],


   services: [
  {
    "name": "Taxi for Mumbai Darshan",
    description: "Looking for a taxi for Mumbai Darshan? AB Ghule Cabs offers reliable and affordable taxi services for a smooth and comfortable tour of Mumbai's famous landmarks. Our well-maintained vehicles and experienced drivers ensure that your Mumbai Darshan is a memorable experience."
  },
  {
    "name": "Mumbai Darshan by Car",
    description: "Enjoy Mumbai Darshan by car with AB Ghule Cabs. We provide convenient and comfortable car rentals for city tours, allowing you to explore Mumbai's major attractions at your own pace. Our professional drivers will guide you through the best sights in the city."
  },
  {
    "name": "Mumbai Darshan Car Rental",
    description: "Rent a car for Mumbai Darshan with AB Ghule Cabs. Choose from a variety of well-maintained vehicles for a comfortable and convenient tour around the city. Our rental services ensure you have a smooth ride while exploring Mumbai's famous tourist spots."
  },
  {
    "name": "Mumbai Darshan Cab Booking",
    description: "Book your Mumbai Darshan cab easily with AB Ghule Cabs. We offer hassle-free cab booking options for your city tour. Whether you're visiting for a day or looking for a longer tour, our well-maintained cabs and experienced drivers ensure you enjoy a safe and comfortable trip."
  },
  {
    "name": "Mumbai Darshan Cab Price",
    description: "Check out the best Mumbai Darshan cab prices with AB Ghule Cabs. We offer competitive pricing for your city tour, with no hidden charges. Enjoy a comfortable ride as you explore Mumbai’s iconic landmarks, all while keeping your budget in mind."
  },
  {
    "name": "Mumbai Darshan Car Booking",
    description: "Book a car for Mumbai Darshan with AB Ghule Cabs. Whether you're visiting the Gateway of India, Marine Drive, or other popular spots, our car booking service ensures a convenient and comfortable travel experience. Choose from a range of vehicles to suit your group size and preferences."
  },
  {
    "name": "Book Cab for Mumbai Darshan",
    description: "Easily book a cab for Mumbai Darshan with AB Ghule Cabs. Our online booking service ensures you can reserve your cab hassle-free, and our professional drivers will take you to all the must-see places in Mumbai, providing a comfortable and smooth journey."
  },
  {
    "name": "Best Cabs for Mumbai Darshan",
    description: "AB Ghule Cabs offers the best cabs for Mumbai Darshan. We provide well-maintained vehicles equipped with modern amenities for a comfortable and enjoyable tour of Mumbai. Our professional drivers will ensure you visit all the important spots in a timely and relaxing manner."
  },
  {
    "name": "Cab Service for Mumbai Darshan",
    description: "Choose AB Ghule Cabs for your Mumbai Darshan cab service. We offer reliable and affordable cab services, ensuring that you have a comfortable journey to explore the beautiful sights of Mumbai. Our experienced drivers will take care of all your needs."
  },
  {
    "name": "Innova for Mumbai Darshan",
    description: "Looking for an Innova for Mumbai Darshan? AB Ghule Cabs offers spacious and comfortable Innova cabs for your city tour. Ideal for families or small groups, our Innova cabs provide ample space and comfort for a relaxing experience while exploring Mumbai's attractions."
  },
  {
    "name": "Mumbai Darshan Cab Charges",
    description: "Check out our Mumbai Darshan cab charges with AB Ghule Cabs. Our pricing structure is transparent, offering affordable rates for your city tour with no hidden costs. Whether you're going for a half-day or full-day tour, our rates are designed to give you the best value for your money."
  },
  {
    "name": "Mumbai Darshan Cab Fare",
    description: "AB Ghule Cabs offers competitive Mumbai Darshan cab fare for your city tour. We ensure clear pricing with no surprises, providing affordable options for both short and extended tours of Mumbai's major landmarks. Enjoy a comfortable ride with our experienced drivers."
  },
  {
    "name": "Mumbai Darshan Cab from Kalyan",
    description: "AB Ghule Cabs offers convenient Mumbai Darshan cabs from Kalyan. Our reliable cab services will take you on a smooth and enjoyable city tour, allowing you to explore all of Mumbai’s top tourist destinations in comfort."
  },
  {
    "name": "Mumbai Darshan Cab from Dadar",
    description: "Book a Mumbai Darshan cab from Dadar with AB Ghule Cabs. We offer affordable and comfortable taxi services for those looking to explore Mumbai from Dadar. Our professional drivers will ensure a smooth and enjoyable journey as you visit the city’s iconic landmarks."
  },
  {
    "name": "Mumbai Darshan Cab from Kharghar",
    description: "Travel from Kharghar to explore Mumbai with AB Ghule Cabs’ Mumbai Darshan cab service. We offer a range of vehicles to ensure a comfortable and convenient city tour, taking you to all the famous sights and landmarks across Mumbai."
  },
  {
    "name": "Mumbai Darshan Cab from Mira Road",
    description: "For a convenient and reliable Mumbai Darshan cab from Mira Road, choose AB Ghule Cabs. Our well-maintained vehicles and experienced drivers will ensure that you enjoy a smooth and comfortable ride while visiting Mumbai’s iconic locations."
  },
  {
    "name": "Mumbai Darshan Cab from Thane",
    description: "AB Ghule Cabs offers Mumbai Darshan cabs from Thane, providing you with an easy and comfortable ride to explore Mumbai’s popular tourist attractions. Our professional drivers ensure a hassle-free journey, making your trip memorable and enjoyable."
  },
  {
    "name": "Mumbai Darshan Cab from Vashi",
    description: "Explore Mumbai with AB Ghule Cabs’ Mumbai Darshan cab service from Vashi. Our affordable and comfortable cabs, paired with experienced drivers, will take you to the best tourist spots in Mumbai, ensuring a smooth and enjoyable experience."
  },
  {
    "name": "Mumbai Darshan Cab Package",
    description: "AB Ghule Cabs offers customized Mumbai Darshan cab packages to suit your travel needs. Whether you're looking for a half-day or full-day tour, our packages include well-maintained cabs and professional drivers for a comfortable and memorable experience."
  },
  {
    "name": "Mumbai Darshan Cabs Near Me",
    description: "Searching for Mumbai Darshan cabs near you? AB Ghule Cabs provides reliable and convenient taxi services for city tours. With our easy booking process and wide range of vehicles, you can book your cab from wherever you are, ensuring a smooth and enjoyable trip."
  },
  {
    "name": "Mumbai Darshan Car Package",
    description: "AB Ghule Cabs offers Mumbai Darshan car packages that include all the must-see sights in Mumbai. Our packages are designed to give you a complete tour experience, with comfortable cars and professional drivers ensuring a pleasant journey."
  },
  {
    "name": "Mumbai Darshan Car Service",
    description: "For Mumbai Darshan car service, AB Ghule Cabs offers reliable and affordable options. Choose from a variety of vehicles for your city tour, and enjoy the convenience of a well-maintained car and experienced drivers."
  },
  {
    "name": "Mumbai Darshan Private Car",
    description: "If you're looking for a private car for Mumbai Darshan, AB Ghule Cabs offers personalized services to suit your needs. Travel in comfort and privacy as you explore the top tourist attractions in Mumbai with a professional driver at your service."
  },
  {
    "name": "Mumbai Darshan Taxi Booking",
    description: "Book your Mumbai Darshan taxi with AB Ghule Cabs today. We offer easy online booking, a range of vehicles to choose from, and professional drivers to make your city tour comfortable and stress-free."
  },
  {
    "name": "Mumbai Darshan Taxi Fare",
    description: "Check the Mumbai Darshan taxi fare with AB Ghule Cabs. We offer clear and competitive pricing, ensuring you get the best value for your city tour. Our affordable rates guarantee a comfortable journey to Mumbai’s most famous landmarks."
  },
  {
    "name": "Mumbai Darshan Taxi Service",
    description: "AB Ghule Cabs offers reliable Mumbai Darshan taxi service, ensuring you get the best tour experience. Our professional drivers and well-maintained taxis ensure a safe, comfortable, and enjoyable journey as you explore Mumbai's iconic sights."
  },
  {
    "name": "One Day Mumbai Darshan by Car",
    description: "Experience a one-day Mumbai Darshan by car with AB Ghule Cabs. Our one-day packages are designed to give you a complete tour of Mumbai’s key attractions, with a professional driver ensuring a smooth and enjoyable experience in just one day."
  },
  {
    "name": "Mumbai Darshan Cabs Contact Number",
    description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai Darshan Cabs. We ensure a smooth and enjoyable ride for all our customers."
  }
],

tableData: [
    ["- Taxi for Mumbai Darshan", "- Mumbai Darshan by car"],
    ["- Mumbai Darshan car rental", "- Mumbai Darshan cab booking"],
    ["- Mumbai Darshan cab price", "- Mumbai Darshan car booking"],
    ["- Book cab for Mumbai Darshan", "- Best cabs for Mumbai Darshan"],
    ["- Cab service for Mumbai Darshan", "- Innova for Mumbai Darshan"],
    ["- Mumbai Darshan cab charges", "- Mumbai Darshan cab fare"],
    ["- Mumbai Darshan cab from Kalyan", "- Mumbai Darshan cab from Dadar"],
    ["- Mumbai Darshan cab from Kharghar", "- Mumbai Darshan cab from Mira Road"],
    ["- Mumbai Darshan cab from Thane", "- Mumbai Darshan cab from Vashi"],
    ["- Mumbai Darshan cab package", "- Mumbai Darshan cabs near me"],
    ["- Mumbai Darshan car package", "- Mumbai Darshan car service"],
    ["- Mumbai Darshan private car", "- Mumbai Darshan taxi booking"],
    ["- Mumbai Darshan taxi fare", "- Mumbai Darshan taxi service"],
    ["- One day Mumbai Darshan by car", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we offer reliable and professional Mumbai Darshan cab services. Our drivers are well-trained, courteous, and committed to providing you with a safe and enjoyable tour of Mumbai's top attractions."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you're planning a morning city tour or an evening drive, we are available 24/7 to cater to your Mumbai Darshan travel needs. Our customer service team is always ready to assist you with your bookings."
    },
    {
      WhyChooseheading: "Affordable Rates",
      WhyChoosedescription: "We offer competitive and transparent pricing for Mumbai Darshan tours, ensuring that you get excellent value for your money. Our prices are designed to fit a range of budgets, whether you’re on a solo trip or with a group."
    },
    {
      WhyChooseheading: "Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are regularly cleaned, maintained, and inspected to ensure a comfortable and hassle-free tour experience. We provide a variety of vehicles, from budget-friendly options to luxury cars, depending on your preferences."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "Safety is our top priority. Our experienced and background-checked drivers ensure a smooth and safe ride throughout your Mumbai Darshan trip. Our vehicles are also equipped with GPS to guide you through the city’s busy roads."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai Darshan cab is simple and convenient. You can book online via our website or mobile app, or contact our customer service for immediate assistance."
    },
    {
      WhyChooseheading: "Customer Satisfaction",
      WhyChoosedescription: "We have a proven track record of customer satisfaction with numerous positive reviews from travelers. We’re committed to making your Mumbai Darshan experience seamless and enjoyable."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai Darshan cab with AB Ghule Cabs?',
      answer: 'You can book a cab for Mumbai Darshan via our website, mobile app, or by calling our customer service helpline. The booking process is fast and easy.',
    },
    {
      id: 'FAQ2',
      question: 'What are the main attractions covered in the Mumbai Darshan tour?',
      answer: 'Our Mumbai Darshan tours typically cover popular landmarks like the Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and more. We can customize your tour based on your preferences.',
    },
    {
      id: 'FAQ3',
      question: 'Are your drivers experienced and familiar with the city?',
      answer: 'Yes, all our drivers are experienced and well-versed with the city\'s routes, ensuring a smooth and informative Mumbai Darshan experience.',
    },
    {
      id: 'FAQ4',
      question: 'Can I customize my Mumbai Darshan tour?',
      answer: 'Yes, we offer customizable tours. You can request to visit specific places, and we will adjust the itinerary to suit your interests.',
    },
    {
      id: 'FAQ5',
      question: 'How do I pay for my Mumbai Darshan ride?',
      answer: 'You can pay for your ride through cash, credit/debit cards, or online payment via our mobile app, offering flexibility and convenience.',
    },
    {
      id: 'FAQ6',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a wide range of vehicles, including sedans, SUVs, and luxury cars for your Mumbai Darshan tour, ensuring a comfortable ride for all kinds of travelers.',
    },
    {
      id: 'FAQ7',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. For assistance, you can also contact our customer service.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer Mumbai Darshan tours for groups?',
      answer: 'Yes, we offer group bookings for Mumbai Darshan tours. Our spacious vehicles can accommodate multiple passengers comfortably for a fun and shared experience.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any additional charges for extra stops or detours?',
      answer: 'Additional charges may apply for extra stops or detours. However, we provide transparent pricing, and any additional charges will be communicated before your journey.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other Mumbai Darshan services?',
      answer: 'AB Ghule Cabs stands out due to our experienced drivers, diverse vehicle options, flexible tours, competitive pricing, and commitment to customer satisfaction.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Amit Sharma",
      feedback: "I recently took the Mumbai Darshan tour with AB Ghule Cabs, and it was a wonderful experience! The driver was knowledgeable and friendly, and the car was very comfortable. We were able to see all the major sights without any hassle. Highly recommend AB Ghule Cabs for anyone visiting Mumbai!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Shalini Desai",
      feedback: "I booked a Mumbai Darshan tour for my family, and we had a fantastic time. The driver was punctual and guided us through the city's most famous attractions. The vehicle was spotless, and the whole process from booking to the ride was seamless. Will definitely use AB Ghule Cabs again for future tours!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Darshan Cab Service | Mumbai Darshan by Car</title>
  <meta name="description" content="Explore Mumbai with affordable Mumbai Darshan cab services. Book a cab for a one-day Mumbai Darshan tour, including options like Innova, and various Mumbai locations such as Kalyan, Dadar, Thane, Vashi, and more." />
  <meta name="keywords" content="Taxi for Mumbai Darshan, Mumbai Darshan by Car, Mumbai Darshan Car Rental, Mumbai Darshan Cab Booking, Mumbai Darshan Cab Price, Book Cab for Mumbai Darshan, Best Cabs for Mumbai Darshan, Cab Service for Mumbai Darshan, Innova for Mumbai Darshan, Mumbai Darshan Cab Charges, Mumbai Darshan Cab Fare, Mumbai Darshan Cab from Kalyan, Mumbai Darshan Cab from Dadar, Mumbai Darshan Cab from Kharghar, Mumbai Darshan Cab from Mira Road, Mumbai Darshan Cab from Thane, Mumbai Darshan Cab from Vashi, Mumbai Darshan Cab Package, Mumbai Darshan Cabs Near Me, Mumbai Darshan Car Package, Mumbai Darshan Car Service, Mumbai Darshan Private Car, Mumbai Darshan Taxi Booking, Mumbai Darshan Taxi Fare, Mumbai Darshan Taxi Service, One Day Mumbai Darshan by Car" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Darshan Cab Service | Mumbai Darshan by Car" />
  <meta property="og:description" content="Explore Mumbai with affordable Mumbai Darshan cab services. Book a cab for a one-day Mumbai Darshan tour, including options like Innova, and various Mumbai locations such as Kalyan, Dadar, Thane, Vashi, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-darshan-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-darshan-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Explore Mumbai with affordable Mumbai Darshan cab services. Book a cab for a one-day Mumbai Darshan tour, including options like Innova, and various Mumbai locations such as Kalyan, Dadar, Thane, Vashi, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-darshan-cab",
        "logo": "https://abghulecabs.com/images/mumbai-darshan-cab.jpg",
        "image": "https://abghulecabs.com/images/mumbai-darshan-cab.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-darshan-cab",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "1800"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh Kumar"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Great service! We had a comfortable ride around Mumbai, and the driver was professional. Highly recommended for a Mumbai Darshan tour."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Deshmukh"
            },
            "datePublished": "2024-09-20",
            "reviewBody": "Excellent Mumbai Darshan service. The cab was clean and well-maintained. The driver took us to all the key spots in Mumbai efficiently."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-darshan-cab"
        },
        "keywords": "Taxi for Mumbai Darshan, Mumbai Darshan by Car, Mumbai Darshan Car Rental, Mumbai Darshan Cab Booking, Mumbai Darshan Cab Price, Book Cab for Mumbai Darshan, Best Cabs for Mumbai Darshan, Cab Service for Mumbai Darshan, Innova for Mumbai Darshan, Mumbai Darshan Cab Charges, Mumbai Darshan Cab Fare, Mumbai Darshan Cab from Kalyan, Mumbai Darshan Cab from Dadar, Mumbai Darshan Cab from Kharghar, Mumbai Darshan Cab from Mira Road, Mumbai Darshan Cab from Thane, Mumbai Darshan Cab from Vashi, Mumbai Darshan Cab Package, Mumbai Darshan Cabs Near Me, Mumbai Darshan Car Package, Mumbai Darshan Car Service, Mumbai Darshan Private Car, Mumbai Darshan Taxi Booking, Mumbai Darshan Taxi Fare, Mumbai Darshan Taxi Service, One Day Mumbai Darshan by Car"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default MumbaiDarshancabs;